import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import Menu from "antd/lib/menu";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import { Link } from "react-router-dom"; // Import Link
import { useSelector } from 'react-redux';

import "./SideMenu.scss";

const { SubMenu } = Menu;

const SideMenu = ({ collapsed, resMenuToggle, setResMenuToggle }) => {
    const [routeName, setRouteName] = useState("/");
    const [openKeys, setOpenKeys] = useState([]);

    const userInfo = useSelector((state) => state.user?.userInfo);
    const userRole = userInfo?.role;


    useEffect(() => {
        setRouteName(window.location.pathname);
    }, []);

    const rootSubmenuKeys = ["sub1", "sub2", "sub3", "sub4", "sub5"];

    // Open only one submenu at a time
    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    return (
        <div
            className={`xl:max-h-[calc(100vh-164px)] overflow-y-auto fixed xl:static top-0 left-0 z-50 min-h-screen xl:min-h-max bg-white -translate-x-full xl:!translate-x-0 w-full xl:w-auto max-w-[300px] transition-all duration-300
        ${resMenuToggle ? " translate-x-0" : ""}`}
        >
            <div className="p-3 bg-white xl:hidden">
                <button
                    className="text-xl"
                    type="button"
                    onClick={() => setResMenuToggle(!resMenuToggle)}
                >
                    <CloseOutlined />
                </button>
            </div>

            <Menu
                defaultSelectedKeys={["1"]}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                mode="inline"
                inlineCollapsed={collapsed}
                className="!border-0"
            >
                {/* DASHBOARD */}
                <Menu.Item
                    key="1"
                    icon={<img alt="" src="/images/dashboard.png" />}
                    className={routeName === "/" ? "active" : "in-active"}
                >
                    <Link to="/">Dashboard</Link>
                </Menu.Item>

                {/* CRON JOB MANAGEMENT */}
                {userRole == "super admin" && <SubMenu
                    key="2"
                    title="Cron Job Settings"
                    icon={<img alt="" src="/images/products.png" />}
                >
                    <Menu.Item key="3">
                        <Link to="/corn-setup">Corn Jobs</Link>
                    </Menu.Item>
                </SubMenu>}

                {/* ORDER MANAGEMENT */}
                <SubMenu
                    key="4"
                    title="Transmission"
                    icon={<img alt="" src="/images/orders.png" />}
                >
                    <Menu.Item key="5">
                        <Link to="/invoice">Invoice</Link>
                    </Menu.Item>
                    <Menu.Item key="6">
                        <Link to="/general">General</Link>
                    </Menu.Item>
                </SubMenu>


                {/* <SubMenu
                    key="7"
                    title="API"
                    icon={<img alt=""src="/images/orders.png" />}
                >
                    <Menu.Item key="8">
                        <Link to="/pages">API</Link>
                    </Menu.Item>
                </SubMenu> */}


                {userRole == "super admin" && <SubMenu
                    key="7"
                    title="Sandbox Page Content"
                    icon={<img alt="" src="/images/orders.png" />}
                >
                    <Menu.Item key="8">
                        <Link to="/pages">Pages</Link>
                    </Menu.Item>
                </SubMenu>}


                <SubMenu
                    key="9"
                    title="APIs"
                    icon={<img alt="" src="/images/orders.png" />}
                >
                    <Menu.Item key="10">
                        <Link to="/page-content/log-in">Log In</Link>
                    </Menu.Item>
                    <Menu.Item key="11">
                        <Link to="/page-content/create-an-item">Create An Item</Link>
                    </Menu.Item>
                    <Menu.Item key="12">
                        <Link to="/page-content/customer">Create A Customer</Link>
                    </Menu.Item>
                    <Menu.Item key="13">
                        <Link to="/page-content/supplier">Create A Supplier</Link>
                    </Menu.Item>
                    <Menu.Item key="14">
                        <Link to="/page-content/cashier">Create An Cashier</Link>
                    </Menu.Item>
                    <Menu.Item key="15">
                        <Link to="/page-content/add-sale">Add Sale</Link>
                    </Menu.Item>
                    <Menu.Item key="16">
                        <Link to="/page-content/refund">Refund</Link>
                    </Menu.Item>
                    <Menu.Item key="17">
                        <Link to="/page-content/lookups">Lookups</Link>
                    </Menu.Item>
                    <Menu.Item key="18">
                        <Link to="/page-content/chasier-list">Chasier List</Link>
                    </Menu.Item>
                    <Menu.Item key="19">
                        <Link to="/page-content/customer-list">Customer List</Link>
                    </Menu.Item>
                </SubMenu>



                {/* CUSTOMER */}
                {/* <SubMenu
                    key="sub3"
                    title="Customers"
                    icon={<img alt=""src="/images/customers.png" />}
                >
                    <Menu.Item key="12">
                        <Link to="/customers">All Customers</Link>
                    </Menu.Item>
                    <Menu.Item key="13">
                        <Link to="/create-customer">Create Customer</Link>
                    </Menu.Item>
                </SubMenu> */}

                {/* SUPPLIER */}
                {/* <SubMenu
                    key="sub4"
                    title="Suppliers"
                    icon={<img alt=""src="/images/suppliers.png" />}
                >
                    <Menu.Item key="14">
                        <Link to="/suppliers">All Suppliers</Link>
                    </Menu.Item>
                    <Menu.Item key="15">
                        <Link to="/create-supplier">Create Supplier</Link>
                    </Menu.Item>
                </SubMenu> */}

                {/* SHOP */}
                {/* <SubMenu
                    key="sub5"
                    title="Store Name"
                    icon={<img alt=""src="/images/shop.png" />}
                >
                    <Menu.Item key="16">
                        <Link to="/shop">All Stores</Link>
                    </Menu.Item>
                    <Menu.Item key="17">
                        <Link to="/create-shop">Create Store</Link>
                    </Menu>
                </SubMenu> */}
            </Menu>
        </div>
    );
};

export default SideMenu;
